import trimHtml from 'trim-html';

import decodeString from 'hb-react/shared/utils/decodeString';

interface Opts {
  limit: number;
  // @deprecated
  moreLink?: string;
  moreText?: string;
  preserveTags?: boolean;
  preserveWhiteSpace?: boolean;
  suffix?: string;
}

interface ReturnType {
  html: string;
  more: boolean;
}

export const truncateHtmlAt = (
  source: string,
  limit?: number,
  opts?: Opts,
): ReturnType => {
  if (!limit) {
    return {
      html: source,
      more: false,
    };
  }

  return trimHtml(decodeString(source), {
    limit,
    ...opts,
  });
};
